import { Component, OnInit } from '@angular/core';
import { LocalSettingsService } from 'app/core/storage';

@Component({
    selector: 'odq-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor(private localSettingsService: LocalSettingsService) { }

  ngOnInit() {
    if (!this.localSettingsService.getClearCache()) {
      // tslint:disable-next-line: deprecation
      console.log('code before reload not found');
      location.reload();
      console.log('code after reload');
      this.localSettingsService.setClearCache();
    }

  }

}
